<div class="edit-details">
  <div>
    <div>{{ 'label.Type' | translate }}:</div>
    <div>
      <select
        name="types"
        [ngModel]="customer && customer.customerTypeId"
        (ngModelChange)="customer && (customer.customerTypeId = $event)"
      >
        <option
          *ngFor="let item of types"
          [value]="item.value"
          [selected]="item.value == customer?.customerTypeId"
        >
          {{ item.text }}
        </option>
      </select>
    </div>
  </div>
  <div>
    <div>{{ 'label.FeedType' | translate }}:</div>
    <div>
      <select
        name="feedType"
        [ngModel]="customer && customer.customerFeedTypeId"
        (ngModelChange)="customer && (customer.customerFeedTypeId = $event)"
      >
        <option
          *ngFor="let item of customerFeedTypes"
          [value]="item.value"
          [selected]="item.value == customer?.customerFeedTypeId"
        >
          {{ item.text }}
        </option>
      </select>
    </div>
  </div>
  <div>
    <div>{{ 'label.Portfolio' | translate }}:</div>
    <div>
      <select
        name="portfolios"
        [ngModel]="customer && customer.customerPortfolio"
        (ngModelChange)="customer && (customer.customerPortfolio = $event)"
        [compareWith]="comparePortfolio"
        [disabled]="!hasEditCustomerPortfolioPermission"
      >
        <option *ngFor="let item of portfolios" [ngValue]="item">
          {{ item.name }}
        </option>
      </select>
    </div>
  </div>
  <div>
    <div>{{ 'label.CustomerName' | translate }}:</div>
    <div>
      <input
        type="text"
        maxlength="200"
        [ngModel]="customer && customer.name"
        (ngModelChange)="customer && (customer.name = $event)"
      />
      <hr-field-state-marker [field]="field?.name"></hr-field-state-marker>
    </div>
  </div>
  <div>
    <div>{{ 'label.CustomerOtherName' | translate }}:</div>
    <div>
      <input
        type="text"
        maxlength="200"
        [ngModel]="customer && customer.name2"
        (ngModelChange)="customer && (customer.name2 = $event)"
      />
      <hr-field-state-marker [field]="field?.name2"></hr-field-state-marker>
    </div>
  </div>
  <div>
    <div>{{ 'label.Industry' | translate }}:</div>
    <!-- <div>
      <select name="industries" [(ngModel)]="customer && customer.industryId">
          <option *ngFor="let item of industries" [value]="item.value" [selected]="item.value==(customer?.industryId)">{{item.text}}</option>
      </select>
    </div> -->
    <div class="filter-inputs">
      <p-multiSelect
        [options]="industryOptions"
        [(ngModel)]="customer.industries"
        dataKey="industryId"
        (onChange)="onIndustryFilterChange($event)"
        [filter]="true"
        [virtualScroll]="true"
        [virtualScrollItemSize]="30"
        [maxSelectedLabels]="1"
        [showToggleAll]="false"
        selectedItemsLabel="{{ 'label.Selected' | translate }}: {0}"
        class="specializations"
        [style]="{
          width: '100%',
          height: '38px',
          border: '1px solid #DDD'
        }"
      >
        <ng-template let-item pTemplate="item">
          <span
            [class.disabled-item]="
              checkDisabledState(customer.industries, item.value.industryId)
            "
            (click)="onIndustryClick($event, item.value)"
            class="{{ item.value.isHead ? 'head-industry' : 'industry' }}"
            >{{ item.label }}</span
          >
        </ng-template>
      </p-multiSelect>
    </div>
  </div>
  <div>
    <div>{{ 'label.NumberOfEmployees' | translate }}:</div>
    <div>
      <select
        name="numberOfEmployees"
        [ngModel]="customer && customer.numberOfEmployeesId"
        (ngModelChange)="customer && (customer.numberOfEmployeesId = $event)"
      >
        <option
          *ngFor="let item of numberOfEmployees"
          [value]="item.value"
          [selected]="item.value == customer?.numberOfEmployeesId"
        >
          {{ item.text }}
        </option>
      </select>
    </div>
  </div>
  <div>
    <div>{{ 'label.City' | translate }}:</div>
    <div>
      <select
        name="localities"
        [ngModel]="customer && customer.locality"
        (ngModelChange)="customer && (customer.locality = $event)"
        [compareWith]="compareLocality"
      >
        <option *ngFor="let item of localities" [ngValue]="item">
          {{ item.name }}
        </option>
      </select>
    </div>
  </div>
  <div>
    <div>{{ 'label.Website' | translate }}:</div>
    <div>
      <input
        type="text"
        [ngModel]="customer && customer.website"
        (ngModelChange)="customer && (customer.website = $event)"
      />
      <hr-field-state-marker [field]="field?.website"></hr-field-state-marker>
    </div>
  </div>
  <div>
    <div>{{ 'label.PublicEmail' | translate }}:</div>
    <div>
      <input
        type="text"
        [ngModel]="customer && customer.publicEmail"
        (ngModelChange)="customer && (customer.publicEmail = $event)"
      />
      <hr-field-state-marker
        [field]="field?.publicEmail"
      ></hr-field-state-marker>
    </div>
  </div>
  <div>
    <div>{{ 'label.Video' | translate }}:</div>
    <div>
      <input
        type="text"
        [ngModel]="customer && customer.videoUrl"
        (ngModelChange)="customer && (customer.videoUrl = $event)"
      />
    </div>
  </div>
  <div>
    <div>{{ 'label.Description' | translate }}:</div>
    <div>
      <ckeditor
        [ngModel]="customer && customer.description"
        (ngModelChange)="customer && (customer.description = $event)"
      ></ckeditor>
    </div>
  </div>
  <div>
    <div>{{ 'label.OtherInfo' | translate }}:</div>
    <div>
      <textarea
        [ngModel]="customer && customer.legacyContactInfo"
        (ngModelChange)="customer && (customer.legacyContactInfo = $event)"
        rows="8"
      ></textarea>
    </div>
  </div>
  <div>
    <div>
      <button
        [disabled]="customer.hasPendingChanges === true"
        (click)="onSaveClick()"
      >
        {{ 'label.Save' | translate }}
      </button>
    </div>
    <div>
      <button (click)="onCancelClick()">
        {{ 'label.Cancel' | translate }}
      </button>
    </div>
  </div>
</div>
